import {axiosErrorHandler} from '@/utils/htmlUtils';
import _ from 'lodash';
class SelectAccount {

    constructor() {
        const logoutConfirmModal = $('.js-confirm-logout-account-modal');
        $('.js-logout-button').click(function () {
            logoutConfirmModal.modal('show');
        });
        logoutConfirmModal.find('.js-confirm-button').click(function () {
            $('#logout-form').submit();
        });

        const categorySearch = $('#categorySearch');
        const categoryMenu = $('#categoryMenu');

        categorySearch.on('input', _.debounce(function(){
            $.ajax({
                url: window.laroute.route('users.category_setting.index'),
                method: 'GET',
                data: { ajax: true, search: categorySearch.val(), checkAuthorize: false },
                success: function(response) {
                    let categories = response.categories;
                    categoryMenu.children().remove();
                    if (categories.length) {
                        categories.forEach(function(element) {
                            let isActive = (element.id == categoryMenu.data('category-id')) ? 'dropdown-content__item--active' : '';

                            categoryMenu.append(`
                                <li class="dropdown-content__item content__remove_max_width ${isActive}" onclick="window.select_account.selectCategory(${JSON.stringify(element).replace(/'/g, '\\\'').replace(/"/g, '&quot;')})">
                                    <a class="dropdown-content__link" href="javascript:void(0)">
                                        ${$('<div>').text(element.name).html()}
                                    </a>
                                </li>
                            `);
                        });
                    } else {
                        categoryMenu.append(`
                            <li class="dropdown-content__item content__remove_max_width">
                                <p class="dropdown-content__link_empty">
                                    ${categoryMenu.data('empty')}
                                </p>
                            </li>`
                        );
                    }
                }
            });
        }, 1000));
    }

    selectAccount(jobType, id = '') {
        this.jobType = jobType;
        this.confirmSwitchAccount(function () {
            window.location.href = window.laroute.route('account.filter-menu', {id: id});
        });
    }

    selectCategory(category) {
        this.categoryName = category.name;
        this.confirmSwitchCategory(function () {
            window.axios.get(window.laroute.route('users.category_setting.select', {category_id: category.id}))
                .then(response => {
                    return location.reload();
                }).catch(errors => {
                    $('.js-confirm-switch-category-modal').modal('hide');

                    axiosErrorHandler(errors, {}, () => {
                        return location.reload();
                    });
                });
        });
    }

    confirmSwitchCategory(callback) {
        let confirmModal = $('.js-confirm-switch-category-modal');
        confirmModal.modal('show');
        let body = confirmModal.find('.modal-body').attr('data-body');
        body = body.replace(':category_name', this.categoryName);
        confirmModal.find('.modal-body').html(body);
        confirmModal.find('.js-confirm-button').click(function () {
            if (callback) {
                callback();
            }
        });
    }

    changeAccount(id, isGoogleAccount, jobType) {
        this.selectedId = id;
        this.jobType = jobType;
        this.sendRequest();
    }

    confirmSwitchAccount(callback) {
        let confirmModal = $('.js-confirm-switch-account-modal');
        confirmModal.modal('show');
        let body = confirmModal.find('.modal-body').attr('data-body');
        body = body.replace(':job_type', this.jobType);
        confirmModal.find('.modal-body').html(body);
        confirmModal.find('.js-confirm-button').click(function () {
            if (callback) {
                callback();
            }
        });
    }

    sendRequest() {
        let self = this;
        $('.js-switch-account-modal').modal('hide');
        this.confirmSwitchAccount(function () {
            window.axios.post(window.laroute.route('account.process_select_account'), {
                id: self.selectedId
            }).then( function () {
                window.location.href = window.laroute.route('default_redirect_url');
            });
        });

    }
}

export default window.select_account = new SelectAccount();
